module.exports = "/images/vendor/flag-icon-css/flags/1x1/sk.svg?a5af0a28a32c844c44fd22d91bdfe018";